export const ROUTE_PATH = {
  LOGIN: '/login',
  MENU: '/',
  MENU_ITEM: '/menu-item',
  CART: '/cart',
  ORDERS: '/orders',
  ORDER: '/order',
  ADMIN_PANEL: '/admin-panel',
  CONSULTANT_SIGN: '/consultant/sign',
  ACCOUNT: '/account',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-and-conditions'
};
